import React, { useEffect, useState } from "react";

import { PageContainer } from "../theme/containers";
import {
    BIFAuthContext,
    BIFAuthProps,
    BIFAuthScreen
} from "./types";
import {
    FailedVerification,
    SuccessfulVerification,
    Verification
} from "./screens";

const renderScreen = (
    screen: BIFAuthScreen,
    props: BIFAuthProps,
    bifContext: BIFAuthContext
) => {
    switch (screen) {
        case "successfulVerification": {
            return <SuccessfulVerification {...props} {...bifContext} />;
        }
        case "failedVerification": {
            return <FailedVerification {...props} {...bifContext} />;
        }
        case "verification":
        default:
            return <Verification {...props} {...bifContext} />;
    }
};

const BIFAuth = (props: BIFAuthProps) => {
    const [screen, setScreen] = useState<BIFAuthScreen>("verification");
    const [email, setEmail] = useState<string>("");
    const [pin, setPin] = useState<string>("");

    const bifContext: BIFAuthContext = {
        screen,
        email,
        pin,
        setScreen,
        setEmail,
        setPin
    };

    useEffect(() => {
        window.dataLayer &&
            window.dataLayer.push({
                event: "screenChange",
                newscreenPath: `/sba/${screen}`
            });
    }, [screen]);

    return (
        <PageContainer pl={0} pr={0} pt={0} flexGrow={1} height={`100%`}>
            {renderScreen(screen, props, bifContext)}
        </PageContainer>
    );
};

export default BIFAuth;
